import {GenericActions} from "./GenericActions";

export class StoreActions {
	constructor(key) {
		this._key = key;
	}

	get key() {
		return this._key;
	}

	static get enum() {
		return {
			actionType: GenericActions.enum.actionType,
		};
	}

	getBackgroundFetchPending() {
		return GenericActions.action.type(`${this.key}_${StoreActions.enum.actionType.BACKGROUND_FETCH_PENDING}`);
	}

	getFetchPending() {
		return GenericActions.action.type(`${this.key}_${StoreActions.enum.actionType.FETCH_PENDING}`);
	}

	getFetchAborted() {
		return GenericActions.action.type(`${this.key}_${StoreActions.enum.actionType.FETCH_ABORTED}`);
	}

	getFetchFulfilled(payload) {
		return GenericActions.action.payload(`${this.key}_${StoreActions.enum.actionType.FETCH_FULFILLED}`, payload);
	}

	getFetchRejected(payload) {
		return GenericActions.action.payload(`${this.key}_${StoreActions.enum.actionType.FETCH_REJECTED}`, payload);
	}

	getBackgroundFetchRejected(payload) {
		return GenericActions.action.payload(`${this.key}_${StoreActions.enum.actionType.BACKGROUND_FETCH_REJECTED}`, payload);
	}

	getItemClear() {
		return GenericActions.action.type(`${this.key}_${StoreActions.enum.actionType.ITEM_CLEAR}`);
	}

	getListClear() {
		return GenericActions.action.type(`${this.key}_${StoreActions.enum.actionType.LIST_CLEAR}`);
	}

	getCacheClear() {
		return GenericActions.action.type(`${this.key}_${StoreActions.enum.actionType.CACHE_CLEAR}`);
	}

	getEditCancel() {
		return GenericActions.action.type(`${this.key}_${StoreActions.enum.actionType.EDIT_CANCEL}`);
	}

	getEditPending() {
		return GenericActions.action.type(`${this.key}_${StoreActions.enum.actionType.EDIT_PENDING}`);
	}

	getEditInit(payload) {
		return GenericActions.action.payload(`${this.key}_${StoreActions.enum.actionType.EDIT_INIT}`, payload);
	}

	getEditFulfilled(payload) {
		return GenericActions.action.payload(`${this.key}_${StoreActions.enum.actionType.EDIT_FULFILLED}`, payload);
	}

	getDeleteFulfilled(payload) {
		return GenericActions.action.payload(`${this.key}_${StoreActions.enum.actionType.ITEM_DELETE}`, payload);
	}

	getEditRejected(payload) {
		return GenericActions.action.payload(`${this.key}_${StoreActions.enum.actionType.EDIT_REJECTED}`, payload);
	}

	getEditModify(value, path, modificationType) {
		return GenericActions.action.modification(`${this.key}_${StoreActions.enum.actionType.EDIT_MODIFY}`, value, path, modificationType);
	}

	getEditSet(payload) {
		return GenericActions.action.payload(`${this.key}_${StoreActions.enum.actionType.EDIT_SET}`, payload);
	}

	generateAsyncFetchActions(background = false) {
		if(background) return this.generateAsyncBackgroundFetchActions();

		return [
			(...props) => this.getFetchPending(...props),
			(...props) => this.getFetchFulfilled(...props),
			(...props) => this.getFetchRejected(...props),
		];
	}

	generateAsyncBackgroundFetchActions() {
		return [
			(...props) => this.getBackgroundFetchPending(...props),
			(...props) => this.getFetchFulfilled(...props),
			(...props) => this.getFetchRejected(...props),
		];
	}

	generateAsyncSendEditActions() {
		return [
			(...props) => this.getEditPending(...props),
			(...props) => this.getEditFulfilled(...props),
			(...props) => this.getEditRejected(...props),
		];
	}
}
